<template>
  <section>
    <SectionHeader />
  </section>
</template>
<script setup>
/* istanbul ignore file */
// Disabling test - as this code is not used by any other file. TODO: HIGH incldue later when this file is used
import useSection from '@common-vue/my-checkout-consumable/useSection';

const props = defineProps({
  sectionKey: {
    type: Symbol,
    required: true,
  },
  headingTag: {
    type: String,
    default: 'h2',
  },
  headingTagStyle: {
    type: String,
    default: 'h3',
  },
});
// Used to Show only Section header for sections which is in INITIAL State
// Having this separate component helps avoid loading main component when any section is in INITIAL state
const {
  SectionHeader, // Section Header
} = useSection({ sectionKey: props.sectionKey, headingTag: props.headingTag, headingTagStyle: props.headingTagStyle });
</script>
